const info = {
  appName: 'Fastback Capture Application',
  shortName: 'FCA',
  companyName: 'Fastback',
  logo: {
    source: {
      uri: 'logo_fastback.png',
    },
    width: 160,
    height: 71,
  },
  description: 'Fastback Capture App enables high level car inspections with helpers and specific user interfaces.',
  vm: false,
  resolution: 'QHD'
};

export default info;
